import React, { PureComponent, Fragment } from "react";
import ubigeo_data from "./data/ubigeo.json";
import SelectItem from "react-select";
const default_param = [
  { value: "00", label: "NACIONAL" }
];
class SelectMultiple extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedItems: default_param
    };
  }
  handleChange = event => {
    if (event === null) {
      event = [];
    }
    let items = [];
    if (event.length > 1) {
      event.map(function(item) {
        if (item.value !== "00") {
          items.push(item);
        }
      });
    } else {
      items = default_param;
    }
    this.setState({ selectedItems: items });
    this.props.onChange(items);
  };
  render() {
    const { selectedItems } = this.state;
    return (
      <Fragment>
        <SelectItem
          isMulti
          placeholder="Seleccione un ámbito"
          onChange={this.handleChange}
          value={selectedItems}
          options={ubigeo_data}
        />
      </Fragment>
    );
  }
}

export default SelectMultiple;
